module.exports = __webpack_public_path__ + "images/icons_v2/raee-28598cf7.svg";